import { render, staticRenderFns } from "./AdminHomeSideMenu.vue?vue&type=template&id=37373537&scoped=true"
import script from "./AdminHomeSideMenu.vue?vue&type=script&lang=js"
export * from "./AdminHomeSideMenu.vue?vue&type=script&lang=js"
import style0 from "./AdminHomeSideMenu.vue?vue&type=style&index=0&id=37373537&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37373537",
  null
  
)

export default component.exports